<template>
    <div
            class="dashboard-page sb-r-c"
            :class="{
                'sb-l-m sb-l-disable-animation': ($route.name === 'dashboard' && $store.state.template.leftMenuOpen === null) || $store.state.template.leftMenuOpen === false,
                'sb-r-o': this.$store.state.template.rightMenuOpenCounter > 0
            }">
        <div id="main">

            <page-header/>
            <left-menu/>

            <section id="content_wrapper">
                <section id="content">
                    <router-view/>
                </section>
            </section>

            <call-panel/>

        </div>

    </div>
</template>

<script>
    import Header from "./Header";
    import LeftMenu from "./LeftMenu";

    export default {
        beforeCreate() {
            this.sockets.subscribe('bid_counter', async data => {
                this.$store.commit('template/setBidCount', data.count);
                this.show = true;
            });
        },
        beforeDestroy() {
            this.sockets.unsubscribe('bid_counter');
        },
        components: {
            pageHeader: Header,
            LeftMenu,
            callPanel: () => import('./CallPanel'),
        },
        async beforeMount() {
            await this.$store.dispatch('template/getBidCount');
            if (this.$store.state.user.meIsLoaded === false) {
                await this.$store.dispatch('user/getMe');
            }
        },
    }
</script>
<style>
    .fc-axis {
        height: 55px !important;
    }

    .fc-event {
        margin: 6px !important;
    }

    .fc-widget-header {
        height: 20px !important
    }

    .fc-title {
        font-weight: 900;
    }

    .popover-content ol {
        padding-left: 20px;
    }

    .sales_subs_id option:disabled {
        background-color: #3498db;
        color: #fff;
    }

    .dashboard_stat .label {
        top: -2px;
        position: relative;
    }

</style>
